import { BreakpointObserver } from '@angular/cdk/layout';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { CommmonService } from 'src/app/utils/common.service';
import { BenefitsService } from 'src/app/home/services/benefits.service';
import { CategoriesService } from 'src/app/home/services/categories.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog } from '@angular/material/dialog';
import { ModalSuccessfulComponent } from './modal-successful/modal-successful.component';
import { FormControl } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Benefits } from 'src/app/home/models/benefts.interface';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss'],
})
export class AddCategoryComponent implements OnInit {
  @ViewChild('fruitInput')
  fruitInput!: ElementRef<HTMLInputElement>;
  isExpanded = true;
  isSizeMobile = false;
  benefits: Benefits[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  seleccionados: string[] = [];
  myControl = new FormControl('');
  filteredBenefits!: Observable<Benefits[]>;
  addOnBlur = true;
  announcer = inject(LiveAnnouncer);

  constructor(
    private breakpointObserver: BreakpointObserver,
    private benefitsService: BenefitsService,
    private categoriesService: CategoriesService,
    private commonService: CommmonService,
    public dialog: MatDialog,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getBenefitsSelect();
    const oritentation = this.breakpointObserver.observe([
      '(max-width: 768px)',
    ]);
    oritentation.subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
      if (this.isSizeMobile) {
        this.isExpanded = true;
      }
    });
    this.filteredBenefits = this.myControl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
        value ? this._filter(value) : this.benefits.slice(),
      ),
    );
  }

  async getBenefitsSelect() {
    this.commonService.setItemLocalStorage(
      'benefits',
      JSON.stringify(this.benefits),
    );
    this.benefits = this.commonService.sortArray(
      (await this.benefitsService.getBenefits()) ?? [],
    );
  }

  openDialog() {
    const dialogRef = this.dialog.open(ModalSuccessfulComponent, {});
    dialogRef.afterClosed().subscribe({});
    this.saveData();
  }

  async saveData() {
    try {
      await this.categoriesService.postCategories({ id: 20, idcategory: 20 });
    } catch (error) {
      console.error('Error al insertar el archivo JSON:', error);
    }
  }

  private _filter(value: string): Benefits[] {
    const filterValue = value.toLowerCase();
    return this.benefits.filter((benefit: { title: string }) =>
      benefit.title.toLowerCase().includes(filterValue),
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.seleccionados.includes(event.option.viewValue)) {
      this.seleccionados.push(event.option.viewValue);
    }
    this.fruitInput.nativeElement.value = '';
    this.myControl.setValue(null);
  }

  remove(beneficio: string): void {
    const index = this.seleccionados.indexOf(beneficio);

    if (index >= 0) {
      this.seleccionados.splice(index, 1);

      this.announcer.announce(`Removed ${beneficio}`);
    }
  }
}
